import { render, staticRenderFns } from "./SimTaskList.vue?vue&type=template&id=1280009a"
import script from "./SimTaskList.vue?vue&type=script&lang=js"
export * from "./SimTaskList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports